import {format as dateFormat, parseISO} from 'date-fns';
import PropTypes from 'prop-types';


const propTypes = {
  value: PropTypes.string,
};

export default function DateCell({value}) {
  if (!value) {
    return '';
  }
  return dateFormat(parseISO(value), 'MM/dd/yyyy');
}
DateCell.propTypes = propTypes;


export function CreatedByDateCell({row, value}) {
  if (!value) {
    return '';
  }
  const {createdBy} = row.original;
  return `${dateFormat(value, 'MM/dd/yyyy')} ${createdBy}`;
}

export function UpdatedByDateCell({row, value}) {
  if (!value) {
    return '';
  }
  const {updatedBy} = row.original;
  return `${dateFormat(value, 'MM/dd/yyyy')} ${updatedBy}`;
}
